import { useCallback, useMemo } from 'react';

import get from 'lodash/get';

import type { IGenericObject } from '../types';

export default function useDataFieldHelpers<T extends IGenericObject>(data) {
  const getValue = useCallback((accessor) => get(data, accessor, ''), [data]);

  const renderValue = useCallback(
    ({ accessor, displayValue }: T) => {
      if (displayValue) {
        return displayValue(getValue(accessor), data);
      }

      return getValue(accessor) || '-';
    },
    [getValue, data],
  );

  const renderLabel = useCallback(
    ({ label }: T) => {
      if (typeof label === 'function') {
        return label(data);
      }

      return label;
    },
    [data],
  );

  const isHidden = useCallback(
    ({ hidden }: T) => {
      if (typeof hidden === 'function') {
        return hidden(data);
      }

      return hidden;
    },
    [data],
  );

  return useMemo(
    () => ({
      renderValue,
      renderLabel,
      isHidden,
    }),
    [isHidden, renderLabel, renderValue],
  );
}
